import api from './api'

const invitationsAPI = {
  // Get invitations by organization
  getByOrganization: async (organizationId, status = null) => {
    const params = status ? `?status=${status}` : ''
    const response = await api.get(`/invitations/organization/${organizationId}${params}`)
    return response.data
  },

  // Create invitation
  create: async (invitationData) => {
    // Include window.location.origin (like copy invitation link)
    const dataWithOrigin = {
      ...invitationData,
      frontend_url: window.location.origin || 'http://localhost:3000'
    }
    const response = await api.post('/invitations', dataWithOrigin)
    return response.data
  },

  // Get invitation by token (public)
  getByToken: async (token) => {
    const response = await api.get(`/invitations/token/${token}`)
    return response.data
  },

  // Accept invitation (public)
  accept: async (token, userData) => {
    const response = await api.post(`/invitations/accept/${token}`, userData)
    return response.data
  },

  // Cancel invitation
  cancel: async (invitationId) => {
    const response = await api.put(`/invitations/${invitationId}/cancel`)
    return response.data
  },

  // Delete invitation
  delete: async (invitationId) => {
    const response = await api.delete(`/invitations/${invitationId}`)
    return response.data
  }
}

export default invitationsAPI


